import React from 'react';
import {
  Button,
  Icon,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';


const ButtonSecondary = withStyles({
  root: {
    background: '#F0F0FF',
    border: '1px solid #D9D8FF',
    borderRadius: '4px'
  }
})(Button);

const AddSubscriptionButton = ({
  isAllowToAddSubscription,
  setOpenAddingSubscriptionsDialog
}) => {
  return (
    <>
      {isAllowToAddSubscription ?
        <ButtonSecondary
          variant="outlined"
          color="primary"
          className="px-6 font-bold"
          onClick={() => setOpenAddingSubscriptionsDialog(true)}
        >
          <span className="flex items-center">
            <Icon className="mr-2">add</Icon>
            <span className="mt-1">Add Subscription Options</span>
          </span>
        </ButtonSecondary>
        :
        <Typography variant="body1" className="mb-4 ml-2 text-muted">
          All available options already created you can delete or edit them.
        </Typography>
      }
    </>
  );
};

export default AddSubscriptionButton;
